import React from 'react';
import styled from 'styled-components';
import Router from 'next/router';
import { Helmet } from 'react-helmet';

import { META_404_TITLE, META_404_DESCRIPTION } from '@/lib/constants';

const Wrapper = styled.div`
    width: auto;
    padding: 0 20px;
`;

const TextWrapper = styled.h2`
    padding-top: 30px;
    text-align: center;
    white-space: pre-line;
    color: rgba(0, 0, 0, 0.64);

    & > span {
        color: #582cdb;
        cursor: pointer;
    }
`;

const Code = styled.div`
    & > div:nth-child(1) {
        color: rgba(0, 0, 0, 0.84);
        font-size: 152px;
        font-weight: bolder;
    }

    & > div:nth-child(2) {
        font-weight: 700;
        color: rgba(0, 0, 0, 0.3);
        font-size: 38px;
        margin-top: 20px;
    }

    display: block;
    margin: 30px 0;
`;

class NotFound extends React.Component {
    constructor(props?: any, context?: any) {
        super(props, context);
    }

    toHomePage = () => {
        window.location.href = 'https://ackodrive.com/';
    };

    metaTagsRender = (title?: any, description?: any) => {
        return (
            <Helmet>
                <meta charSet="UTF-8" />
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
        );
    };

    render() {
        return (
            <div>
                <Wrapper>
                    <>
                        <Code>
                            <div>404</div>{' '}
                            <div>We couldn’t find this page.</div>
                        </Code>
                        <TextWrapper>
                            Take me back to{' '}
                            <span onClick={this.toHomePage}>ackodrive.com</span>
                        </TextWrapper>
                        {this.metaTagsRender(
                            META_404_TITLE,
                            META_404_DESCRIPTION
                        )}
                    </>
                </Wrapper>
            </div>
        );
    }
}

export default NotFound;
